const fullWidthImageStyle = {
    image:{
      maxWidth:"100%",
      borderRadius: "6px 6px 0px 0px",
    },
    box:{
      textAlign:"left",
      width:"100%",
      borderRadius: "6px 6px 0px 0px",
      backgroundColor:"#ecedef"

    }
  };
  export default fullWidthImageStyle;